import React from "react";
import Markdown from "react-markdown";

import Image from "next/image";

export default function Sample({
  sample_desc,
  sample_response_graph,
}: {
  sample_desc?: string;
  sample_response_graph?: string;
}) {
  return (
    <div className="tab-pane fade show active">
      {sample_desc && (
        <div className="g2-text-grey">
          <Markdown>{sample_desc}</Markdown>
        </div>
      )}

      {sample_response_graph && (
        <div className="text-center my-4">
          <Image src={sample_response_graph} className="img-fluid" alt="Sample Graph" width={1000} height={100} />
        </div>
      )}
    </div>
  );
}
